import { useEffect } from "react";
import { init, backButton } from '@telegram-apps/sdk-react';
import { useNavigate } from "react-router-dom";

export const useBackButton = (backRoute = "/", isEnable = true, useHistoryBack = false, isFunc = false, func) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    if (window.Telegram?.WebApp) {
        // Показываем кнопку "Назад"
      if (isEnable) backButton.show();

      // Обработчик для кнопки "Назад"
      const off = backButton.onClick(() => {
        if (isFunc) {
          func();
        }
        else {
          if (useHistoryBack) {
            window.history.back(); // Обычный переход назад
          } else {
            navigate(backRoute); // Переход на указанный маршрут
          }
        }
        
      });

      // Очистка при размонтировании
      return () => {
        off(); // Отключаем обработчик
        backButton.hide(); // Скрываем кнопку "Назад"
      };
    }
    
  }, [backRoute, navigate, useHistoryBack]);
};
